import React from 'react';
import { Wifi, Waves, Wind, Tv, WashingMachine, Car, Coffee, UtensilsCrossed, Home, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const featuredIcons = [Wifi, Waves, Wind, Tv, WashingMachine, Car, Coffee, UtensilsCrossed];

export const Amenities = () => {
  const { t } = useLanguage();
  const indoorItems = t('amenitiesSection.indoorItems');
  const outdoorItems = t('amenitiesSection.outdoorItems');
  const featured = t('amenitiesSection.featured');

  return (
    <section className="amenities-section">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="section-badge">{t('amenitiesSection.badge')}</div>
          <h2 className="section-title">{t('amenitiesSection.title')}</h2>
          <p className="section-description">{t('amenitiesSection.description')}</p>
        </div>

        <div className="amenities-grid">
          <div className="amenities-column">
            <div className="amenities-column-header">
              <Home className="h-6 w-6 text-imperial-red" />
              <h3>{t('amenitiesSection.indoor')}</h3>
            </div>
            <ul className="amenities-list">
              {Array.isArray(indoorItems) && indoorItems.map((amenity, index) => (
                <li key={index} className="amenities-list-item">
                  <span className="amenity-bullet"></span>
                  {amenity}
                </li>
              ))}
            </ul>
          </div>

          <div className="amenities-column">
            <div className="amenities-column-header">
              <Sparkles className="h-6 w-6 text-imperial-red" />
              <h3>{t('amenitiesSection.outdoor')}</h3>
            </div>
            <ul className="amenities-list">
              {Array.isArray(outdoorItems) && outdoorItems.map((amenity, index) => (
                <li key={index} className="amenities-list-item">
                  <span className="amenity-bullet"></span>
                  {amenity}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="featured-amenities">
          {Array.isArray(featured) && featured.map((label, index) => {
            const IconComponent = featuredIcons[index];
            return (
              <div key={index} className="featured-amenity-item">
                <IconComponent className="featured-amenity-icon" />
                <span>{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
